const DEFAULT_HERO_IMAGE = '/hero-background.jpg';

function PageHero({
  eyebrow,
  title,
  subtitle,
  children,
  variant = 'page',
  imageSrc = DEFAULT_HERO_IMAGE,
  showStripes = false,
  titleId,
}) {
  return (
    <header className={`c-hero c-hero--${variant}`}>
      <div className="c-hero__image-background" aria-hidden="true">
        <img src={imageSrc} alt="" className="c-hero__image" />
      </div>
      <div className="c-hero__overlay" aria-hidden="true" />

      <div className="c-hero__content">
        <div className="c-hero__inner">
          {eyebrow ? <p className="c-hero__eyebrow">{eyebrow}</p> : null}
          <h1 id={titleId} className="c-hero__title">{title}</h1>
          {subtitle ? <p className="c-hero__subtitle">{subtitle}</p> : null}
          {children ? <div className="c-hero__actions">{children}</div> : null}
        </div>
      </div>

      {showStripes ? (
        <div className="c-hero__stripes" aria-hidden="true">
          <div className="c-stripes" />
        </div>
      ) : null}
    </header>
  );
}

export default PageHero;
